import { render, staticRenderFns } from "./match-recommend-st.vue?vue&type=template&id=5f2fcf2d&scoped=true"
import script from "./match-recommend-st.vue?vue&type=script&lang=js"
export * from "./match-recommend-st.vue?vue&type=script&lang=js"
import style0 from "./match-recommend-st.vue?vue&type=style&index=0&id=5f2fcf2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2fcf2d",
  null
  
)

export default component.exports